import React, { useContext, useEffect, useState } from 'react'
import theme from '@ifca-root/react-component/src/assets/theme'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import { AppBar, List, ListItem, ListItemText, Tab, Tabs, useMediaQuery } from '@material-ui/core'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useCreateDigitalMenuItemPriceMutation,
  
  useCreateDigitalMenuWithExcelMutation,
  
  useCreateMenuItemWithExcelMutation,
  useGetCheckingDigitalMenuItemPriceValidationQuery,
//   useCreateCompanyImportMutation,
//   useGetCheckingValidationCompanyQuery,
  useGetCheckingValidationMenuItemQuery,
  useGetCheckingValidationQuery,
  useGetOutletQuery
} from 'generated/graphql'
import { SystemMsgs } from '../../../../helpers/SystemMsg'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { type } from 'os'
import AppContext from 'containers/App/Store/AppContext'

export const DigitalMenuitemExcelValidation = (props: any) => {
  const { outletID } = useParams<any>();
  const { mode } = props
  let location = useLocation()
  const passedData: any = location?.state
  const excelData = passedData.excelData
  const fileName = passedData.fileTitle
  const { globalState }: any = useContext(AppContext as any);
  let history = useHistory()
  const { CompanyID, BankAccountID }: any = useParams()
  const { accType }: any = useParams()
  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
  })
  const [openDialog, setOpenDialog] = useState(false)
  const [errorNumberingStructure, setErrorNumberingStructure] = useState(false)
  const [sheetCategory,setSheetCategory]= useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [validatedSheets,setValidatedSheets] = useState([]);
  const [hasExcelSheetError,setHasExcelSheetError]=useState(false);
//   const {
//     loading: CheckingValidationMenuItemLoading,
//     error: getCheckingValidationMenuItemError,
//     data: { getCheckingValidationMenuItem } = {
//       getCheckingValidationMenuItem: [],
//     },
//   } = useGetCheckingValidationMenuItemQuery({
//     fetchPolicy: 'network-only',
//     variables: {
//       MenuItemImportInput: passedData.excelData,
//       outletID: outletID
//     },
//     onCompleted: ({ getCheckingValidationMenuItem }) => {
//       let ErrorData: any = []
//       let ValidData: any = []
//  console.log("getCheckingValidationMenuItem",getCheckingValidationMenuItem);
 
//       getCheckingValidationMenuItem?.map(x => {
//         if (x['ErrorList']?.length > 0)
//           ErrorData.push({
//             name: x['name']?.trim(),
//             nativeName: x['nativeName']?.trim(),
//             kitchenName: x['kitchenName']?.trim(),
//             description: x['description']?.trim(),
//             major: x['major']?.trim(),
//             family: x['family']?.trim(),
//             kitchenPrinter: x['kitchenPrinter']?.trim(),
//             taxschemes: x['taxschemes']?.trim(),
//             uom: x['uom']?.trim(),
//             defaultQuantity: parseFloat(x['defaultQuantity']),
//             isOpenItem: x['isOpenItem'].trim(),
//             isOpenPrice: x['isOpenPrice'].trim(),
//             isChefRecommended: x['isChefRecommended'].trim(),
//             isQuantityControlled: x['isQuantityControlled'].trim(),
//             isDiscountable: x['isDiscountable'].trim(),
//             isByWeight: x['isByWeight'].trim(),
//             standardCost: parseFloat(x['standardCost']),
//             isPerforated: x['isPerforated'].trim(),
//             perforatedQuantity:parseFloat(x['perforatedQuantity']),
//             ErrorList: x['ErrorList'],
//           })
//         else
//           ValidData.push({
//             name: x['name']?.trim(),
//             nativeName: x['nativeName']?.trim(),
//             kitchenName: x['kitchenName']?.trim(),
//             description: x['description']?.trim(),
//             major: x['major']?.trim(),
//             family: x['family']?.trim(),
//             kitchenPrinter: x['kitchenPrinter']?.trim(),
//             taxschemes: x['taxschemes']?.trim(),
//             uom: x['uom']?.trim(),
//             defaultQuantity: Number(x['defaultQuantity']),
//             isOpenItem: x['isOpenItem']?.trim(),
//             isOpenPrice: x['isOpenPrice']?.trim(),
//             isChefRecommended: x['isChefRecommended']?.trim(),
//             isQuantityControlled: x['isQuantityControlled']?.trim(),
//             isDiscountable: x['isDiscountable']?.trim(),
//             isByWeight: x['isByWeight']?.trim(),
//             standardCost: Number(x['standardCost']),
//             isPerforated: x['isPerforated']?.trim(),
//             perforatedQuantity:Number(x['perforatedQuantity']),
//             ErrorList: x['ErrorList'],
//           })
//       })

//       setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
//     },
//   })
//  console.log("Passed data:", passedData.excelData);

useEffect(()=>{
  // console.log("Updated sheetCategory:",sheetCategory);
  if(!validatedSheets.length){
    return
  }
  const selectsheet = validatedSheets[selectedTab];

  let ErrorData = [];
  let ValidData = [];

  selectsheet.rows.map(row=>{
    if (row.ErrorList?.length>0) {
      ErrorData.push(row);
    }else{
      ValidData.push(row);
    }
  })


  setValidatedData({ErrorData,ValidData});
},[selectedTab,validatedSheets]);
  const {loading:GetCheckingValidationloading,
    error: GetCheckingValidationError,
    data: { getCheckingDigitalMenuItemPriceValidation} = {
      getCheckingDigitalMenuItemPriceValidation: [],
    },
  }= useGetCheckingDigitalMenuItemPriceValidationQuery({
    fetchPolicy:'network-only',
    variables:{
      sheets:[ 
        {
          excelData: passedData.excelData
        }
      ], 
      outletID
    },
    onCompleted:({getCheckingDigitalMenuItemPriceValidation })=>{
      console.log("passeddata",passedData.excelData);
      const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
    
      const findsheet = (data,name)=>{
        if(!data|| !data.length){
          return null;
        }
        const group = data[0];

        const lowername = normalize(name);
        console.log('Data',data,"group",group.digitalmenu);
        
        for(const key of Object.keys(group)){
          const sheetArray = group[key];
          console.log('sheetArray',sheetArray);

          if (!Array.isArray(sheetArray)) {
            continue;
          }

          console.log("Checking Key:",key,"array:",sheetArray);

          const foundSheet =sheetArray.find(s=>normalize(s.sheetName) ===lowername);
          if (foundSheet) {
            return foundSheet;
          } 
        }
        console.warn(`Sheet ${name} not found in group`,group);
        return null;
      }
    
    
      const digitalmenusheet = findsheet(getCheckingDigitalMenuItemPriceValidation,"DigitalMenu");
      const digitalmenucategorysheet = findsheet(getCheckingDigitalMenuItemPriceValidation,"DigitalMenuCategory");
      const digitalmenuitemformsheet = findsheet(getCheckingDigitalMenuItemPriceValidation,"DigitalMenuItemForm");
      const digitalmenuitempriceformsheet =findsheet(getCheckingDigitalMenuItemPriceValidation,"DigitalMenuItemPriceForm"); 
      
      const SheetName = digitalmenusheet?.sheetName?? "";
      console.log("digitalmenusheet",digitalmenusheet);
       console.log("digitalmenuSheetName",SheetName);
      console.log("digitalmenucategorysheet",digitalmenucategorysheet);
      console.log("digitalmenuitemformsheet",digitalmenuitemformsheet);
      console.log("digitalmenuitempriceformsheet",digitalmenuitempriceformsheet);
      console.log("BACKEND RESULT:", JSON.stringify(getCheckingDigitalMenuItemPriceValidation, null, 2));
      
      const allSheets =( [
       { sheetName: "DigitalMenu", rows: digitalmenusheet.rows },
       { sheetName: "DigitalMenuCategory", rows: digitalmenucategorysheet.rows },
       { sheetName: "DigitalMenuItemForm", rows: digitalmenuitemformsheet.rows },
       { sheetName: "DigitalMenuItemPriceForm", rows: digitalmenuitempriceformsheet.rows },
      ]);
      setValidatedSheets(allSheets);


      const sheetcategorylist = Object.keys(passedData.excelData[0]);


      console.log("digitalmenusheetcategorylist",sheetcategorylist);

      // setSheetCategory(sheetcategorylist);
      setSheetCategory(allSheets.map(s=>s.sheetName));

      if (!digitalmenusheet) {
        console.error("MenuItemList sheet not found");
        return;
      }

      console.log("Sending sheets:", JSON.stringify(passedData.excelData, null, 2));

      const digitalmenurows = digitalmenusheet.rows;
      const digitalmenucategoryrows = digitalmenucategorysheet.rows;
      const digitalmenuitemformrows = digitalmenuitemformsheet.rows;
      const digitalmenuitempriceformrows = digitalmenuitempriceformsheet.rows;
      let ErrorData: any = []
      let ValidData: any = []
      const digitalMenuCategoryItemCount = {};
      for (const worksheetName of sheetcategorylist){
        if (normalize(worksheetName)=== "digitalmenu") {
          digitalmenurows.map(x=>{
            const data = x;
            const errors = x?.ErrorList??[];

            if (x['ErrorList']?.length >0) {
              ErrorData.push({
                outletName: data.outletName?.trim(),
                name:data.name?.trim(),
                description:data.description?.trim(),
                ErrorList: errors,
              })
            } else{
              ValidData.push({
                outletName: data.outletName?.trim(),
                name:data.name?.trim(),
                description:data.description?.trim(),
                ErrorList: errors,
              })
            }
          });
        }
        if (normalize(worksheetName)=== "digitalmenucategory") {
          digitalmenucategoryrows.map(x=>{
            const data = x;
            const errors = x?.ErrorList??[];

            if (x['ErrorList']?.length>0) {
              ErrorData.push({
                digitalMenuName:data.digitalMenuName?.trim(),
                outletName:data.outletName?.trim(),
                name:data.name?.trim(),
                priority:Number(data.priority),
                ErrorList: errors,
              })
            }else{
               ValidData.push({
                digitalMenuName: data.digitalMenuName?.trim(),
                outletName:data.outletName?.trim(),
                name:data.name?.trim(),
                priority:Number(data.priority),
                ErrorList: errors,
              })
            }
          })
        }
        if (normalize(worksheetName)=== "digitalmenuitemform") {
          digitalmenuitemformrows.map(x=>{
            const data = x;
            const errors = x?.ErrorList??[];
            const digitalMenuCategoryKey = x.digitalMenuCategoryName?.trim().toLowerCase();
            const digitalMenuCategoryItemKey = x.menuItemName?.trim().toLowerCase();
            if (!digitalMenuCategoryKey||!digitalMenuCategoryItemKey) {
              return;
            }
            if (!digitalMenuCategoryItemCount[digitalMenuCategoryKey]) {
              digitalMenuCategoryItemCount[digitalMenuCategoryKey] ={};
            }

            digitalMenuCategoryItemCount[digitalMenuCategoryKey][digitalMenuCategoryItemKey]= (digitalMenuCategoryItemCount[digitalMenuCategoryKey][digitalMenuCategoryItemKey] || 0)+1;
            if (digitalMenuCategoryKey&& digitalMenuCategoryItemKey) {
             if (digitalMenuCategoryItemCount[digitalMenuCategoryKey][digitalMenuCategoryItemKey] >1) {
              errors.push("menutemName cannot have duplicate name")
             }
            }

            if (x['ErrorList']?.length>0) {
              ErrorData.push({
                outletName:data.outletName?.trim(),
                digitalMenuCategoryName:data.digitalMenuCategoryName?.trim(),
                menuItemName:data.menuItemName?.trim(),
                ErrorList: errors,
              })
            }else{
              ValidData.push({
                outletName:data.outletName?.trim(),
                digitalMenuCategoryName:data.digitalMenuCategoryName?.trim(),
                menuItemName:data.menuItemName?.trim(),
                ErrorList: errors,
              })
            }
          })
        }
        if (normalize(worksheetName)=== "digitalmenuitempriceform") {
          digitalmenuitempriceformrows.map(x=>{
            const data = x;
            const errors = x?.ErrorList??[];

            if (x['ErrorList']?.length>0) {
              ErrorData.push({
                outletName:data.outletName?.trim(),
                digitalMenuName:data.digitalMenuName?.trim(),
                patronType:data.patronType?.trim(),
                price:parseFloat(data.price),
                ErrorList: errors,
              })
            }else{
               ValidData.push({
                outletName:data.outletName?.trim(),
                digitalMenuName:data.digitalMenuName?.trim(),
                patronType:data.patronType?.trim(),
                price:parseFloat(data.price),
                ErrorList: errors,
              })
            }
          })
        }


        let excelsheeterror = false;
        for(const sheet of allSheets){
          if (sheet.rows.some(r=>r.ErrorList?.length>0)) {
            excelsheeterror= true;
            break;
          }
        }
        setHasExcelSheetError(excelsheeterror);
      }
      const menuSheet = getCheckingDigitalMenuItemPriceValidation.find(
        s=> s.sheetName.toLowerCase()=== "digitalmenu"
      );
      console.log("digitalmenuSheet",menuSheet);
      
      if (!menuSheet) {
        console.error("digitalmenusheet not found");
        return;
      }
     console.log("Sending sheets:", JSON.stringify(passedData.excelData, null, 2));
      const rows = menuSheet.rows;
      console.log('sheetrows',rows);
      console.log('digitalmenuSheet',menuSheet);
      
      


      // rows.map(x => {
      //    if (x['ErrorList']?.length > 0){
      //       ErrorData.push({
      //         // type
      //         name: x['name']?.trim(),
      //         nativeName: x['nativeName']?.trim(),
      //         kitchenName: x['kitchenName']?.trim(),
      //         description: x['description']?.trim(),
      //         major: x['major']?.trim(),
      //         family: x['family']?.trim(),
      //         kitchenPrinter: x['kitchenPrinter']?.trim(),
      //         taxschemes: x['taxschemes']?.trim(),
      //         uom: x['uom']?.trim(),
      //         defaultQuantity: parseFloat(x['defaultQuantity']),
      //         isOpenItem: x['isOpenItem']?.trim(),
      //         isOpenPrice: x['isOpenPrice']?.trim(),
      //         isChefRecommended: x['isChefRecommended']?.trim(),
      //         isQuantityControlled: x['isQuantityControlled']?.trim(),
      //         isDiscountable: x['isDiscountable']?.trim(),
      //         isByWeight: x['isByWeight']?.trim(),
      //         standardCost: parseFloat(x['standardCost']),
      //         isPerforated: x['isPerforated']?.trim(),
      //         perforatedQuantity:parseFloat(x['perforatedQuantity']),
      //         ErrorList: x['ErrorList'],
      //       })
      //     }
      //   else
      //     ValidData.push({
      //       name: x['name']?.trim(),
      //       nativeName: x['nativeName']?.trim(),
      //       kitchenName: x['kitchenName']?.trim(),
      //       description: x['description']?.trim(),
      //       major: x['major']?.trim(),
      //       family: x['family']?.trim(),
      //       kitchenPrinter: x['kitchenPrinter']?.trim(),
      //       taxschemes: x['taxschemes']?.trim(),
      //       uom: x['uom']?.trim(),
      //       defaultQuantity: Number(x['defaultQuantity']),
      //       isOpenItem: x['isOpenItem']?.trim(),
      //       isOpenPrice: x['isOpenPrice']?.trim(),
      //       isChefRecommended: x['isChefRecommended']?.trim(),
      //       isQuantityControlled: x['isQuantityControlled'].trim(),
      //       isDiscountable: x['isDiscountable']?.trim(),
      //       isByWeight: x['isByWeight']?.trim(),
      //       standardCost: Number(x['standardCost']),
      //       isPerforated: x['isPerforated']?.trim(),
      //       perforatedQuantity:Number(x['perforatedQuantity']),
      //       ErrorList: x['ErrorList'],
      //     })
      // });
      setValidatedData({ErrorData,ValidData});
    }
  })
  const [
    createmenuitemwithExcel,
    {
    loading:CreateMenuItemWithExcelloading,
    data: CreateMenuItemWithExcel
    }
  ]= useCreateMenuItemWithExcelMutation({
    // fetchPolicy: 'network-only',
    //   variables: {
    //     menuItemInput: passedData.excelData,
    //     outletID: outletID
    //   },
        onCompleted: () => {
        // let ErrorData: any = []
        // let ValidData: any = []
        console.log("CreateMenuItemWithExcel",CreateMenuItemWithExcel);
        setSnackBarMsg(SystemMsgs.createNewRecord());

      
          history.push({
             pathname: `/menu/outlet-app/outlet-setting/${outletID}/digital-menu`,
            state:{success:true,msgMode:'create'}
          })
        // getCheckingValidationMenuItem?.map(x => {
        //   if (x['ErrorList']?.length > 0)
        //     ErrorData.push({
        //       name: x['name'],
        //       nativeName: x['nativeName'],
        //       kitchenName: x['kitchenName'],
        //       description: x['description'],
        //       uomID: x['uomID'],
        //       defaultQuantity: Number(x['defaultQuantity']),
        //       isOpenItem: x['isOpenItem'],
        //       isOpenPrice: x['isOpenPrice'],
        //       isChefRecommended: x['isChefRecommended'],
        //       isQuantityControlled: x['isQuantityControlled'],
        //       isDiscountable: x['isDiscountable'],
        //       isByWeight: x['isByWeight'],
        //       standardCost: Number(x['standardCost']),
        //       isPerforated: x['isPerforated'],
        //       perforatedQuantity:Number(x['perforatedQuantity']),
        //       ErrorList: x['ErrorList'],
        //     })
        //   else
        //     ValidData.push({
        //       name: x['name'],
        //       nativeName: x['nativeName'],
        //       kitchenName: x['kitchenName'],
        //       description: x['description'],
        //       uomID: x['uomID'],
        //       defaultQuantity: Number(x['defaultQuantity']),
        //       isOpenItem: x['isOpenItem'],
        //       isOpenPrice: x['isOpenPrice'],
        //       isChefRecommended: x['isChefRecommended'],
        //       isQuantityControlled: x['isQuantityControlled'],
        //       isDiscountable: x['isDiscountable'],
        //       isByWeight: x['isByWeight'],
        //       standardCost: Number(x['standardCost']),
        //       isPerforated: x['isPerforated'],
        //       perforatedQuantity:Number(x['perforatedQuantity']),
        //       ErrorList: x['ErrorList'],
        //     })
        // })

        // setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
      },
  })

  const [
    createdigitalmenuitemwithexcel,
    {
      loading:createDigitalMenuItemWithExcelloading,
    data: CreateDigitalMenuItemWithExcel
    }
  ]= useCreateDigitalMenuWithExcelMutation({
    onCompleted:()=>{
      console.log("CreateDigitalMenuWothExcel",CreateDigitalMenuItemWithExcel);

      setSnackBarMsg(SystemMsgs.createNewRecord());

      history.push({
        pathname:`/menu/outlet-app/outlet-setting/${outletID}/digital-menu`,
        state:{sucess:true,msgMode:'create' }
      })
      
    }
  })
  const handleChange = (event,newValue) => {
    setSelectedTab(newValue);
	};
//   const [
//     createCompanyImport,
//     { loading: createCompanyLoading, error: createCompanyImportError },
//   ] = useCreateCompanyImportMutation({
//     onError: error => {
//       console.log('ERROR', error)
//     },
//     onCompleted: data => {
//       setOpenSnackBar(true)
//       setSnackBarMsg(SystemMsgs.createNewRecord())
//       history.push({
//         pathname: `/company-setup`,
//         state: {
//           success: true,
//           msgMode: 'create',
//         },
//       })
//     },
//   })

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    //setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2()

  // const createCompanyExcel = data => {
  //   let stringifyData = JSON.stringify(data)

  //   // createCompanyImport({
  //   //   variables: {
  //   //     TemplateStr: stringifyData,
  //   //   },
  //   // })
  // }
  const {
      called: ouletCalled,
      loading: outletLoading,
      error: outletError,
      data: { getOutlet } = { getOutlet: [] },
    } = useGetOutletQuery({
      fetchPolicy: 'network-only',
      variables: { ID: outletID },
    });
  const outletArray: any[] = getOutlet;
  const createMenuItemExcel = data =>{
     let stringifyData = JSON.stringify(data)

     createMenuItemExcel({
        variables: {
          TemplateStr: stringifyData,
        },
     });
  }

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      {/* {checkingValidationCompanyLoading && <Loading />}
      {createCompanyLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => history.push(`/company-setup`)}
        smTitle={'Company Setup'}
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Company Setup', current: true },
        ]}
      /> */}
        <MainHeader
            onClick={() => {
                // localStorage.setItem(
                //     `searchFilter`,
                //     JSON.stringify({
                //         outletList: menuItemSearch?.outletList ?? '',
                //         outletSubmenu: menuItemSearch?.outletSubmenu ?? '',
                //         menuItemSearch: '',
                //     }),
                // );
                history.push({
                    pathname: `/menu/outlet-app/outlet-setting/${outletID}/digital-menu`,
                });
            }}
            mainBtn="close"
            smTitle={`Outlet App`}
            title={outletArray[0]?.name}
            // title={outletArray[0]?.name}
            routeSegments={[
                { name: 'Outlet Settings' },
                { name: 'Digital Menu', current: true },
            ]}
        />
      <DynamicSubHeader
        style={{
          marginTop: '-2px',
        }}
        title={'Digital Menu  Excel Upload'}
        rightText={<span className="c-orange">Validation</span>}
      />
      <List className="search-header fixed-search-header with-dynamic">
        <ListItem>
          <ListItemText
            primary={
              <>
                <span className="xsTitle flex-space">{fileName}</span>
              </>
            }
          />
        </ListItem>
      </List>

      <div
				className="core-tab"
				style={{
					position: 'fixed',
					padding: '0px',
					width:
						isDesktop && globalState.drawerOpen
							? 'inherit'
							: '-webkit-fill-available',
				}}
			>
      <AppBar position="static">
        <Tabs
          aria-label="simple tabs example"
          indicatorColor="primary"
          textColor="primary"
          value={selectedTab}
          onChange={handleChange}
          variant={'scrollable'}
        >
          {/* {getOutletDailyMenuCategory
            .sort((a, b) => Number(a.priority) - Number(b.priority))
            ?.map((x, index) => (
              <Tab label={x?.name} {...a11yProps(index)} />
            ))} */}
            {/* {sheetCategory.map((x)=>{
              <Tab label={x?.sheet}  />
            })} */}
            {sheetCategory?.map((sheet,index)=>(
                <Tab key={index} label={sheet}/>
            ))}
        </Tabs>
      </AppBar>

      </div>

      <ContentWrapper
        style={{ marginTop: isDesktop ? '140px' : '75px' }}
        float
        footer
      >
        {/* Problem List */}
        {sheetCategory.map((s,index)=>{
          if (index !== selectedTab) {
            return null;
          }
          const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
          console.log("normalize result = ",normalize(s));
          console.log("digitalmeneusheet",normalize(s) === "digitalmenu");


          if (normalize(s)=== "digitalmenu") {
            return(
            <>
              {validatedData.ErrorData?.length > 0 && (
                <>
                  <List style={{ marginBottom: '-13px' }}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                              Problem{' '}
                              {
                                <>
                                  (
                                  <span className="highlight-text">
                                    {validatedData.ErrorData?.length}
                                  </span>
                                  )
                                </>
                              }
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                  <List className="core-list">
                    {validatedData.ErrorData?.map((el, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          // style={{
                          //   textAlign: 'right',
                          //   marginLeft: '5px',
                          // }}
                          primary={
                            <>
                              <div style={{ width: '100%' }}>

                                <div>
                                  <span className="desc">outletName: {el.outletName}</span>
                                </div>

                                <div>
                                  <span className="desc">
                                    Name: {el.name}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">Description: {el.description}</span>
                                </div>
                                {/* {el?.Status === 'Active' && (
                                  <div
                                    className="blue-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                                {el?.Status === 'Inactive' && (
                                  <div
                                    className="grey-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Inactive
                                  </div>
                                )} */}
                              </div>
                            </>
                          }
                          
                          secondary={
                            <>
                              <div>
                                {/* <div
                                  className="xsTitle text-noflow"
                                  style={{ color: 'red' }}
                                >
                                  {' '}
                                  DefaultQuantity: {el.defaultQuantity}
                                </div> */}
                                <div
                                  className="xsTitle text-noflow"
                                  style={{ color: 'red' }}
                                >
                                  {' '}
                                  {el.ErrorList?.map((x, index) => {
                                    if (index == el.ErrorList?.length - 1)
                                      return `${x}`
                                    else return `${x}, `
                                  })}
                                </div>
                              </div>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
              {validatedData.ValidData?.length > 0 && (
              <>
                <List style={{ marginBottom: '-13px' }}>
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                            Validated{' '}
                            {
                              <>
                                (
                                <span className="highlight-text">
                                  {validatedData.ValidData?.length}
                                </span>
                                )
                              </>
                            }
                          </span>
                        </>
                      }
                    />
                  </ListItem>
                </List>
                <List className="core-list">
                  {validatedData.ValidData?.map((el, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        // style={{
                        //   textAlign: 'right',
                        //   marginLeft: '5px',
                        // }}
                        
                        primary={
                          <>
                            <div style={{ width: '100%' }}>
                              <div>
                                <span className="xsTitle flex-space ">
                                  outletName: {el.outletName}{' '}
                                </span>
                              </div>

                              <div>
                                <span className="desc">Name: {el.name}</span>
                              </div>

                              <div>
                                <span className="desc">Description: {el.description}</span>
                              </div>
                              
                              <div>
                                <span className="desc">
                                  {' '}
                                  {el.ErrorList?.map((x, index) => {
                                        if (index == el.ErrorList?.length - 1)
                                            return `${x}`
                                        else return `${x}, `
                                    })}
                                </span>
                              </div>
                              {/* {el?.Status === 'Active' && (
                                <div
                                  className="blue-status"
                                  style={{
                                    padding: '5px',
                                    margin: '0px',
                                    borderRadius: '2px',
                                  }}
                                >
                                  Active
                                </div>
                              )}
                              {el?.Status === 'Inactive' && (
                                <div
                                  className="grey-status"
                                  style={{
                                    padding: '5px',
                                    margin: '0px',
                                    borderRadius: '2px',
                                  }}
                                >
                                  Inactive
                                </div>
                              )} */}
                            </div>
                          </>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </>
              )}
            </>)
          }

          if (normalize(s)=== "digitalmenucategory") {
            return(
              <>
                {validatedData.ErrorData?.length > 0 && (
                  <>
                    <List style={{ marginBottom: '-13px' }}>
                      <ListItem>
                        <ListItemText
                          primary={
                            <>
                              <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                                Problem{' '}
                                {
                                  <>
                                    (
                                    <span className="highlight-text">
                                      {validatedData.ErrorData?.length}
                                    </span>
                                    )
                                  </>
                                }
                              </span>
                            </>
                          }
                        />
                      </ListItem>
                    </List>
                    <List className="core-list">
                      {validatedData.ErrorData?.map((el, index) => (
                        <ListItem key={index}>
                          <ListItemText
                            // style={{
                            //   textAlign: 'right',
                            //   marginLeft: '5px',
                            // }}
                            primary={
                              <>
                                <div style={{ width: '100%' }}>

                                  <div>
                                    <span className="desc">digitalMenuName: {el.digitalMenuName}</span>
                                  </div>

                                  <div>
                                    <span className="desc">
                                      outletName: {el.outletName}
                                    </span>
                                  </div>
                                  <div>
                                    <span className="desc">name: {el.name}</span>
                                  </div>
                                  <div>
                                    <span className="desc">priority: {el.priority}</span>
                                  </div>
                                  {/* {el?.Status === 'Active' && (
                                    <div
                                      className="blue-status"
                                      style={{
                                        padding: '5px',
                                        margin: '0px',
                                        borderRadius: '2px',
                                      }}
                                    >
                                      Active
                                    </div>
                                  )}
                                  {el?.Status === 'Inactive' && (
                                    <div
                                      className="grey-status"
                                      style={{
                                        padding: '5px',
                                        margin: '0px',
                                        borderRadius: '2px',
                                      }}
                                    >
                                      Inactive
                                    </div>
                                  )} */}
                                </div>
                              </>
                            }
                            
                            secondary={
                              <>
                                <div>
                                  {/* <div
                                    className="xsTitle text-noflow"
                                    style={{ color: 'red' }}
                                  >
                                    {' '}
                                    DefaultQuantity: {el.defaultQuantity}
                                  </div> */}
                                  <div
                                    className="xsTitle text-noflow"
                                    style={{ color: 'red' }}
                                  >
                                    {' '}
                                    {el.ErrorList?.map((x, index) => {
                                      if (index == el.ErrorList?.length - 1)
                                        return `${x}`
                                      else return `${x}, `
                                    })}
                                  </div>
                                </div>
                              </>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}
                {validatedData.ValidData?.length > 0 && (
                <>
                  <List style={{ marginBottom: '-13px' }}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                              Validated{' '}
                              {
                                <>
                                  (
                                  <span className="highlight-text">
                                    {validatedData.ValidData?.length}
                                  </span>
                                  )
                                </>
                              }
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                  <List className="core-list">
                    {validatedData.ValidData?.map((el, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          // style={{
                          //   textAlign: 'right',
                          //   marginLeft: '5px',
                          // }}
                          
                          primary={
                            <>
                              <div style={{ width: '100%' }}>
                                <div>
                                  <span className="xsTitle flex-space ">
                                    digitalMenuName: {el.digitalMenuName}{' '}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">outletName: {el.outletName}</span>
                                </div>
                                <div>
                                  <span className="desc">name: {el.name}</span>
                                </div>

                                <div>
                                  <span className="desc">priority: {el.priority}</span>
                                </div>
                                
                                <div>
                                  <span className="desc">
                                    {' '}
                                    {el.ErrorList?.map((x, index) => {
                                          if (index == el.ErrorList?.length - 1)
                                              return `${x}`
                                          else return `${x}, `
                                      })}
                                  </span>
                                </div>
                                {/* {el?.Status === 'Active' && (
                                  <div
                                    className="blue-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                                {el?.Status === 'Inactive' && (
                                  <div
                                    className="grey-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Inactive
                                  </div>
                                )} */}
                              </div>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </>
                )}
              </>
            )
          }
          
          if (normalize(s)=== "digitalmenuitemform") {
            return(
              <>
                {validatedData.ErrorData?.length > 0 && (
                  <>
                    <List style={{ marginBottom: '-13px' }}>
                      <ListItem>
                        <ListItemText
                          primary={
                            <>
                              <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                                Problem{' '}
                                {
                                  <>
                                    (
                                    <span className="highlight-text">
                                      {validatedData.ErrorData?.length}
                                    </span>
                                    )
                                  </>
                                }
                              </span>
                            </>
                          }
                        />
                      </ListItem>
                    </List>
                    <List className="core-list">
                      {validatedData.ErrorData?.map((el, index) => (
                        <ListItem key={index}>
                          <ListItemText
                            // style={{
                            //   textAlign: 'right',
                            //   marginLeft: '5px',
                            // }}
                            primary={
                              <>
                                <div style={{ width: '100%' }}>

                                  <div>
                                    <span className="desc">
                                      outletName: {el.outletName}
                                    </span>
                                  </div>
                                  <div>
                                    <span className="desc">digitalMenuCategoryName: {el.digitalMenuCategoryName}</span>
                                  </div>
                                  <div>
                                    <span className="desc">menuItemName: {el.menuItemName}</span>
                                  </div>
                                  {/* {el?.Status === 'Active' && (
                                    <div
                                      className="blue-status"
                                      style={{
                                        padding: '5px',
                                        margin: '0px',
                                        borderRadius: '2px',
                                      }}
                                    >
                                      Active
                                    </div>
                                  )}
                                  {el?.Status === 'Inactive' && (
                                    <div
                                      className="grey-status"
                                      style={{
                                        padding: '5px',
                                        margin: '0px',
                                        borderRadius: '2px',
                                      }}
                                    >
                                      Inactive
                                    </div>
                                  )} */}
                                </div>
                              </>
                            }
                            
                            secondary={
                              <>
                                <div>
                                  {/* <div
                                    className="xsTitle text-noflow"
                                    style={{ color: 'red' }}
                                  >
                                    {' '}
                                    DefaultQuantity: {el.defaultQuantity}
                                  </div> */}
                                  <div
                                    className="xsTitle text-noflow"
                                    style={{ color: 'red' }}
                                  >
                                    {' '}
                                    {el.ErrorList?.map((x, index) => {
                                      if (index == el.ErrorList?.length - 1)
                                        return `${x}`
                                      else return `${x}, `
                                    })}
                                  </div>
                                </div>
                              </>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}
                {validatedData.ValidData?.length > 0 && (
                <>
                  <List style={{ marginBottom: '-13px' }}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                              Validated{' '}
                              {
                                <>
                                  (
                                  <span className="highlight-text">
                                    {validatedData.ValidData?.length}
                                  </span>
                                  )
                                </>
                              }
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                  <List className="core-list">
                    {validatedData.ValidData?.map((el, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          // style={{
                          //   textAlign: 'right',
                          //   marginLeft: '5px',
                          // }}
                          
                          primary={
                            <>
                              <div style={{ width: '100%' }}>
                                <div>
                                  <span className="xsTitle flex-space ">
                                    outletName: {el.outletName}{' '}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">digitalMenuCategoryName: {el.digitalMenuCategoryName}</span>
                                </div>

                                <div>
                                  <span className="desc">menuItemName: {el.menuItemName}</span>
                                </div>
                                
                                <div>
                                  <span className="desc">
                                    {' '}
                                    {el.ErrorList?.map((x, index) => {
                                          if (index == el.ErrorList?.length - 1)
                                              return `${x}`
                                          else return `${x}, `
                                      })}
                                  </span>
                                </div>
                                {/* {el?.Status === 'Active' && (
                                  <div
                                    className="blue-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                                {el?.Status === 'Inactive' && (
                                  <div
                                    className="grey-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Inactive
                                  </div>
                                )} */}
                              </div>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </>
                )}
              </>
            )
          }

          if (normalize(s) === "digitalmenuitempriceform") {
            return (
            <>
              {validatedData.ErrorData?.length > 0 && (
                <>
                  <List style={{ marginBottom: '-13px' }}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                              Problem{' '}
                              {
                                <>
                                  (
                                  <span className="highlight-text">
                                    {validatedData.ErrorData?.length}
                                  </span>
                                  )
                                </>
                              }
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                  <List className="core-list">
                    {validatedData.ErrorData?.map((el, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          // style={{
                          //   textAlign: 'right',
                          //   marginLeft: '5px',
                          // }}
                          primary={
                            <>
                              <div style={{ width: '100%' }}>

                                <div>
                                  <span className="desc">
                                    outletName: {el.outletName}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">digitalMenuItemName: {el.digitalMenuItemName}</span>
                                </div>
                                <div>
                                  <span className="desc">patronType: {el.patronType}</span>
                                </div>
                                <div>
                                  <span className="desc">price: {el.price}</span>
                                </div>
                                {/* {el?.Status === 'Active' && (
                                  <div
                                    className="blue-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                                {el?.Status === 'Inactive' && (
                                  <div
                                    className="grey-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Inactive
                                  </div>
                                )} */}
                              </div>
                            </>
                          }
                          
                          secondary={
                            <>
                              <div>
                                {/* <div
                                  className="xsTitle text-noflow"
                                  style={{ color: 'red' }}
                                >
                                  {' '}
                                  DefaultQuantity: {el.defaultQuantity}
                                </div> */}
                                <div
                                  className="xsTitle text-noflow"
                                  style={{ color: 'red' }}
                                >
                                  {' '}
                                  {el.ErrorList?.map((x, index) => {
                                    if (index == el.ErrorList?.length - 1)
                                      return `${x}`
                                    else return `${x}, `
                                  })}
                                </div>
                              </div>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
              {validatedData.ValidData?.length > 0 && (
              <>
                <List style={{ marginBottom: '-13px' }}>
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                            Validated{' '}
                            {
                              <>
                                (
                                <span className="highlight-text">
                                  {validatedData.ValidData?.length}
                                </span>
                                )
                              </>
                            }
                          </span>
                        </>
                      }
                    />
                  </ListItem>
                </List>
                <List className="core-list">
                  {validatedData.ValidData?.map((el, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        // style={{
                        //   textAlign: 'right',
                        //   marginLeft: '5px',
                        // }}
                        
                        primary={
                          <>
                            <div style={{ width: '100%' }}>
                              <div>
                                <span className="xsTitle flex-space ">
                                  outletName: {el.outletName}{' '}
                                </span>
                              </div>

                              <div>
                                <span className="desc">digitalMenuItemName: {el.digitalMenuItemName}</span>
                              </div>
                              <div>
                                <span className="desc">patronType: {el.patronType}</span>
                              </div>
                              <div>
                                <span className="desc">price: {el.price}</span>
                              </div>
                              
                              <div>
                                <span className="desc">
                                  {' '}
                                  {el.ErrorList?.map((x, index) => {
                                        if (index == el.ErrorList?.length - 1)
                                            return `${x}`
                                        else return `${x}, `
                                    })}
                                </span>
                              </div>
                              {/* {el?.Status === 'Active' && (
                                <div
                                  className="blue-status"
                                  style={{
                                    padding: '5px',
                                    margin: '0px',
                                    borderRadius: '2px',
                                  }}
                                >
                                  Active
                                </div>
                              )}
                              {el?.Status === 'Inactive' && (
                                <div
                                  className="grey-status"
                                  style={{
                                    padding: '5px',
                                    margin: '0px',
                                    borderRadius: '2px',
                                  }}
                                >
                                  Inactive
                                </div>
                              )} */}
                            </div>
                          </>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </>
              )}
            </>
            
            )
          }
        })}
      </ContentWrapper>

      <ExcelInput
        showFooter={false}
        showDupErrors={true}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openFileUpload}
        setOpenUpload={setOpenFileUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        onUploadTemplate={async () => {
          const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
          const exceldata = [
            {
              menuitemlist:[],
              digitalmenu:[]
            }
          ];
          const validated = {ErrorData:[],ValidData:[]};
          const previousValidated = passedData?.validatedData ?? {ErrorData:[],ValidData:[]};
          const sheetvalidation = (sheetName,mapping)=>{
            const sheet = currentData.find(
              s=>normalize(s.sheetName) === normalize(sheetName));
            if (!sheet) {
              console.warn(`Sheet ${sheet} not found`);
              return null;
            }
            // exceldata[0][key]=[
            //  { sheetName:sheetName,
            //   rows:sheet.rows.map(mapping)}
            // ];

            exceldata[0].digitalmenu.push({
              sheetName:sheetName,
              rows:sheet.rows.map(mapping)
            })

            // return mappedRows;// return to validate locally
        };

        const digitalmenurows = 
        sheetvalidation("DigitalMenu",x=>{
          const oldError = previousValidated.ErrorData.find(r=>r.name ===x.name)?.ErrorList||[];
        return{					
          outletName: x?.outletName === null ? null:`${x?.outletName?.trim()}`,
					name: x?.name=== null? null:`${x?.name?.trim()}`,
          description: x?.description === null?null:`${x?.description.trim()}`,
          ErrorList: Array.isArray(x?.ErrorList)?x.ErrorList:oldError,}
          
				});
        
        if (digitalmenurows) {
          digitalmenurows.map(row =>{
            console.log("digitalmenurowserrorlist",row.ErrorList);            
            if (row.ErrorList?.length>0) {
              validated.ErrorData.push(row);
            }else{
              validated.ValidData.push(row);
            }
          })
        }


        const digitalmenucategoryrows = 
        sheetvalidation("DigitalMenuCategory",x=>{
          const oldError = previousValidated.ErrorData.find(r=>r.name=== x.name)?.ErrorList||[];
          return {
            digitalMenuName:x?.digitalMenuName === null ?null:`${x?.digitalMenuName?.trim()}`,
            outletName: x?.outletName === null ? null:`${x?.outletName?.trim()}`,
            name: x?.name=== null? null:`${x?.name?.trim()}`,
            priority:x?.priority === null?null:Number(x?.priority),
            ErrorList: oldError
          }
        });


        if (digitalmenucategoryrows) {
            digitalmenucategoryrows.map(rows =>{
              console.log("digitalmenucategoryrowserrorlist",rows.ErrorList);

              if (rows.ErrorList?.length > 0) {
                validated.ErrorData.push(rows);
              }else{
                validated.ValidData.push(rows);
              }
            })        
        }

        const digitalmenuitemformrows = 
        sheetvalidation("DigitalMenuItemForm",x=>{
          const oldError = previousValidated.ErrorData.find(r=>r.name===x.name )?.ErrorList||[];
          return{
            outletName:x?.outletName === null ? null:`${x?.outletName?.trim()}`,
            digitalMenuCategoryName:x?.digitalMenuCategoryName  === null? null:`${x?.digitalMenuCategoryName?.trim()}`,
            menuItemName:x?.menuItemName === null? null:`${x?.menuItemName?.trim()}`,
            ErrorList:oldError,
          }
        })

        if (digitalmenuitemformrows) {
          digitalmenuitemformrows.map(rows=>{
          console.log("digitalmenucategoryrowserrorlist",rows.ErrorList);

          if (rows.ErrorList?.length >0) {
            validated.ErrorData.push(rows);
          }else{
            validated.ValidData.push(rows);
          }
          })
        }

        const digitalmenuitampriceformrows = 
        sheetvalidation("DigitalMenuItemPriceForm",x=>{
          const oldError = previousValidated.ErrorData.find(r=>r.name === x.name)?.ErrorList||[];
          return {
            outletName:x?.outletName === null?null:`${x?.outletName?.trim()}`,
            digitalMenuItemName: x?.digitalMenuItemName === null?null:`${x?.digitalMenuItemName?.trim()}`,
            patronType:x?.patronType === null?null:`${x?.patronType?.trim()}`,
            price:x?.price === null?null :Number(x?.price),
            ErrorList:oldError,
          }
        });
        
        if (digitalmenuitampriceformrows) {
          digitalmenuitampriceformrows.map(rows=>{
            console.log("digitalmenuitemformrowserrorlist",rows.ErrorList);
            if (rows?.ErrorList?.length > 0) {
              validated.ErrorData.push(rows)
            }
            else{
              validated.ValidData.push(rows);
            }
          })
        }


        // if (testRows) {
        //   testRows.map(row=>{
        //     console.log('TestingRowarrorlist',row.ErrorList);
        //     if (row.ErrorList?.length>0) {
        //       validated.ErrorData.push(row)
        //     }else{
        //       validated.ValidData.push(row)
        //     }
        //   })
        // }

        setValidatedData(validated);
          history.push({
            pathname: setOpenFileUpload? `/menu/outlet-app/outlet-setting/${outletID}/digital-menu/excel-validation`:`/menu/outlet-app/outlet-setting/${outletID}/digital-menu`,
            state: {
              excelData:exceldata,
              
            //   currentData?.map(x => {
            //     console.log("isPerforated",x);
            //     return {
            //       name:
            //         x?.name === null ? null : `${x?.name?.trim()}`,
            //       nativeName:
            //         x?.nativeName === null ? null : `${x?.nativeName?.trim()}`,
            //       kitchenName:
            //         x?.kitchenName === null ? null : `${x?.kitchenName?.trim()}`,
            //       description:
            //         x?.description === null ? null : `${x?.description?.trim()}`,
            //       major:
            //         x?.major === null ? null : `${x?.major?.trim()}`,
            //       family:
            //         x?.family === null ? null : `${x?.family?.trim()}`,
            //       kitchenPrinter:
            //         x?.kitchenPrinter === null ? null : `${x?.kitchenPrinter?.trim()}`,
            //       taxschemes:
            //         x?.taxschemes === null ? null : `${x?.taxschemes?.trim()}`,
            //       uom: x?.uom === null ? null : `${x?.uom?.trim()}`,
            //       defaultQuantity: x?.defaultQuantity === null ? null : Number(`${x?.defaultQuantity}`),
            //       isOpenItem:String(x?.isOpenItem).trim(),
            //       isOpenPrice: String(x?.isOpenPrice).trim(),
            //       isChefRecommended: String(x?.isChefRecommended).trim(),
            //       isQuantityControlled: String(x?.isQuantityControlled).trim(),
            //       isDiscountable: String(x?.isDiscountable).trim() ,
            //       isByWeight: String(x?.isByWeight).trim() ,
            //       standardCost: x?.standardCost === null ? null : Number(`${x?.standardCost}`),
            //       isPerforated: String(x?.isPerforated).trim(),
            //       perforatedQuantity: x?.perforatedQuantity === null ? null : Number(`${x?.perforatedQuantity}`),
            //       // Status: x?.Status === null ? null : `${x?.Status}`,
            //       ErrorList: x?.ErrorList,
            //     }
            //   }
            // ),
              fileTitle: fileTitle,
            },
          })
            setOpenFileUpload(false)
            resetFileUpload()
            setFileTitle('')
          
         
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={() => {}}
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: snackBarMessage,
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />
      <Footer
        options={
          // validatedData.ErrorData?.length === 0 &&
          // validatedData.ValidData?.length > 0
          !hasExcelSheetError
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true)
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenFileUpload(true)
                  },
                },
              ]
        }
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
        }}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <span
                    className="title c-orange flex-space"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                  >
                    Upload Confirmation
                  </span>
                </div>
              </div>
            ),
          },
          body: () => (
            <div>
              <span>{'Are you sure to upload?'}</span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                      // createMenuItemExcel(useGetCheckingValidationMenuItemQuery);
                    // createCompanyExcel(getCheckingValidationCompany)
                    // createmenuitemwithExcel({
                    //  variables: {
                    //   MenuItemImportInput: passedData.excelData,
                    //   outletID: outletID
                    // },
                    // })

                    const groupedSheets =passedData.excelData[0]
                    createdigitalmenuitemwithexcel({
                      variables:{
                        sheets:[{
                          excelData:[groupedSheets]
                        }],
                        outletID:outletID
                      }
                    })
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <CommonDialog
        fullWidth={true}
        open={errorNumberingStructure}
        onClose={() => {
          setErrorNumberingStructure(false)
        }}
        sections={{
          header: {
            dynamic: (
              // <div className="">
              //   <div className="dialog-dynamic-content">
              //     <span
              //       className="title c-orange flex-space"
              //       style={{
              //         fontSize: '13px',
              //         fontWeight: 'bold',
              //       }}
              //     >
              //       Error!
              //     </span>
              //   </div>
              // </div>

              <>
                <span className="xsTitle flex-space" style={{ color: 'red' }}>
                  Error!
                </span>
              </>
            ),
          },
          body: () => (
            <div>
              <span>
                {'Document Numbering for External Journal is not created.'}
              </span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => {
                    setErrorNumberingStructure(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </>
  )
}
